import React, { useState, useEffect } from 'react';
import { useLinksContext } from '@context/LinksContext';

interface CanvasCacheBannerProps {
    message: React.ReactNode;
}

const CanvasCacheBanner: React.FC<CanvasCacheBannerProps> = ({ message }) => {
  const { schoolLink } = useLinksContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (schoolLink.schoolLinkUrl) {
        setIsVisible(true);
    }
  }, [schoolLink.schoolLinkUrl]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`canvas-banner ${isVisible ? 'visible' : ''}`}>
      <div className='message'>{message}</div>
      <button
        className="close-btn"
        aria-label="Close"
        onClick={handleClose}
      >
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.33325 3.92708L12.7613 13.3552" stroke="#767676" stroke-width="3" stroke-linecap="round"/>
        <path d="M3.33325 13.2604L12.7613 3.83233" stroke="#767676" stroke-width="3" stroke-linecap="round"/>
      </svg>
      </button>
    </div>
  );
};

export default CanvasCacheBanner;